<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'followUps.modal.searchFollowUps' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="close()"></i>
  </div>
  <div class="modal-body">
    <div class="row align-items-center mb-3">
      <label class="col-3 label">{{
        'followUps.modal.labels.kitId' | translate
      }}</label>
      <div class="col-9">
        <input
          type="text"
          class="w-100 form-control"
          data-cy="follow-ups-search-fu-by-kit-id"
          [formControl]="kitIdControl"
          [placeholder]="'followUps.modal.placeholders.kitId' | translate"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      [disabled]="kitIdControl.invalid || loading()"
      (click)="submit()"
    >
      @if (loading()) {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      } @else {
        {{ 'followUps.modal.buttons.search' | translate }}
      }
    </button>
  </div>
</div>
